import React from 'react';
import { SubscribeFormWrapper } from './styles';
import ProgressiveForm from 'components/Form/ProgressiveForm';

const SidebarSubscribeForm = ({ content, formValues, onSubmit, sticky, ...otherProps }) => {
  return (
    <SubscribeFormWrapper
      {...otherProps}
      sticky={sticky}
      secondStep={formValues['email'] && !formValues['industry']}
    >
      <div className="blog-details--subscribe-form-title">{content.formTitle}</div>

      <ProgressiveForm
        dataPosition="Side Bar"
        formValues={formValues}
        onSubmit={onSubmit}
        buttonTitle={['Subscribe', 'Submit']}
        className="blog-details--subscribe-form blog-details--subscribe-form-active"
        enableNotification={true}
        notificationMessage="Thanks for subscribing! Please check your mail to confirm your subscription"
        notificationStyles="section-blog-details-form-notification"
        revealProps={{
          styles: 'section-blog-details-legal-info',
          content: (
            <>
              By entering your information above and clicking this button, you agree that we may
              contact you at the phone number or email address you provide in this form. Our{' '}
              <a href="/terms-of-use" target="_blank">
                Terms of Use
              </a>{' '}
              and{' '}
              <a href="/privacy-policy" target="_blank">
                Privacy Policy
              </a>{' '}
              apply.
            </>
          ),
        }}
      />
    </SubscribeFormWrapper>
  );
};

export default SidebarSubscribeForm;
